// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__3T01r","logos":"styles_logos__1AEOz","heading":"styles_heading__56SCu","text":"styles_text__3Lcd9","backgroundImage":"styles_backgroundImage__K5N_Z"};